<module-container>
  <div class="title-container">
    <h2>List of Documents</h2>
    <p>Documents that have line items not mapped to a Master Product.</p>
  </div>
  <abcis-table [configuration]="tableConfig" (linkClick)="onLinkClick($event)"></abcis-table>
</module-container>
